export default "/images/vendor/flag-icon-css/flags/1x1/nl.svg?f9d570ec865ab2c1e9d4c00bfe653190";